import { useEffect as c } from "react";
const f = (t, o) => {
  c(() => {
    o(t);
  }, [t]);
};
export {
  f as useWatch
};
